/**
 * Raise the boot-level suite-navigation overlay WITH its reason (BH-06).
 *
 * The shared boot slice has one refusal status (`workspace_closed`). Three
 * Central verdicts land there, and they need different words:
 *
 *   WORKSPACE_CLOSED   → "Workspace closed"
 *   WORKSPACE_PICKER   → "Workspace access removed"   (MEMBERSHIP_INACTIVE / _REVOKED)
 *   APP_ACCESS_DENIED  → "Access denied"               (BeHeard not assigned)
 *
 * Every site that raises the overlay goes through here so the reason and the
 * status are always set together.
 */

import type { CentralFailureAction } from './centralFailureContract';
import { extractOtherWorkspaces } from './centralFailureContract';
import {
  setBootDenial,
  setBootWorkspaceClosed,
  type BootDenialReason,
} from '../store/slices/centralAuthSlice';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Dispatch = (action: any) => unknown;

/** The overlay reason for a classifier verdict, or null when it raises no overlay. */
export function denialReasonFor(action: CentralFailureAction): BootDenialReason | null {
  switch (action) {
    case 'WORKSPACE_CLOSED':
      return 'workspace_closed';
    case 'WORKSPACE_PICKER':
      return 'membership';
    case 'APP_ACCESS_DENIED':
      return 'app_access_denied';
    default:
      return null;
  }
}

/** Record the reason, then raise the overlay with the workspaces still reachable. */
export function raiseBootDenial(
  dispatch: Dispatch,
  reason: BootDenialReason,
  code: string | null,
  body: unknown,
): void {
  dispatch(setBootDenial({ reason, code }));
  dispatch(setBootWorkspaceClosed({ otherWorkspaces: extractOtherWorkspaces(body) as never }));
}
